(function (angular) {
    'use strict';

    angular.module('app', [
        'ui.bootstrap',
        'ui.router',
        'angular-loading-bar',
        'ncy-angular-breadcrumb',
        'ngAnimate',
        'ngCacheBuster',
        'ngCookies',
        'ngFileUpload',
        'ngResource',
        'ngStorage',
        'ngTable',
        'ngTagsInput',
        'pascalprecht.translate',
        'ui-leaflet',
        'rzModule',
        'thatisuday.ng-image-gallery',
        'infinite-scroll',
        'angular-sortable-view',
        'oc.lazyLoad',
        'ngSanitize'

    ]).run(appRun);

    /* @ngInject */
    function appRun($rootScope, $translate, stateHandler) {

        stateHandler.initialize();

        $rootScope.changeLanguage = function (key) {
            $translate.use(key);
            $translate.refresh();
        };
    }
})
(angular);
